/**
 * @var propDeps Tells react we only want mount/unmount to call the effect
 *
 * useEffect has magic [] to only run effect on mount/unmount
 * I didn't like the magic so added a constant :)
 */
export var ReactHookEffectMountUnmount = [];
//# sourceMappingURL=constants.js.map